//Imports from same Package: none

import {ExpressionPath} from '@packages/systems/wfdl';

export const ADD_UL = 'ADD_UL' as const;
export const ADD_OL = 'ADD_OL' as const;
export const ADD_MEDIA = 'ADD_MEDIA' as const;
export const ADD_HTML_EMBED = 'ADD_HTML_EMBED' as const;
export const ADD_IMAGE = 'ADD_IMAGE' as const;
export const ADD_CODE_BLOCK = 'ADD_CODE_BLOCK' as const;
export const ADD_BLOCK_QUOTE = 'ADD_BLOCK_QUOTE' as const;
export const ADD_PARAGRAPH = 'ADD_PARAGRAPH' as const;
export const ADD_H1 = 'ADD_H1' as const;
export const ADD_H2 = 'ADD_H2' as const;
export const ADD_H3 = 'ADD_H3' as const;
export const ADD_H4 = 'ADD_H4' as const;
export const ADD_H5 = 'ADD_H5' as const;
export const ADD_H6 = 'ADD_H6' as const;
export const ADD_AI_PARAGRAPH = 'ADD_AI_PARAGRAPH' as const;
export const ADD_COMPONENT = 'ADD_COMPONENT' as const;

// As Content Editor toolbars are rewritten, we'll move them to this new menu constant
export const CONTENT_EDITOR_MENUS = {
  ADD_MENU: 'addMenu',
  ADD_IMAGE_MENU: 'addImageMenu',
  ADD_RICH_CONTENT_MENU: 'addRichContentMenu',
  ADD_COMPONENT_MENU: 'addComponentMenu',
  ADD_PLUS_BUTTON: 'addPlusButton',
  AI_EDIT_MENU: 'aiEditMenu',
  AI_PROMPT_MENU: 'aiPromptMenu',
  AI_LOADING_BAR: 'aiLoadingBar',
} as const;

export type FormatToolbarButtonsType = {
  bold: boolean;
  italic: boolean;
  link: boolean;
  span: boolean;
  clear: boolean;
  h1: boolean;
  h2: boolean;
  h3: boolean;
  h4: boolean;
  h5: boolean;
  h6: boolean;
  blockquote: boolean;
  ol: boolean;
  ul: boolean;
  superscript: boolean;
  subscript: boolean;
  inlineCode: boolean;
};

export const DEFAULT_FORMAT_TOOLBAR_BUTTONS: FormatToolbarButtonsType = {
  bold: false,
  italic: false,
  link: false,
  span: false,
  clear: false,
  h1: false,
  h2: false,
  h3: false,
  h4: false,
  h5: false,
  h6: false,
  blockquote: false,
  ol: false,
  ul: false,
  superscript: false,
  subscript: false,
  inlineCode: false,
};

export const FORMAT_BUTTONS = {
  bold: 'bold',
  italic: 'italic',
  link: 'link',
  span: 'span',
  superscript: 'superscript',
  subscript: 'subscript',
  inlineCode: 'inlineCode',
} as const;

export type FORMAT_BUTTON = keyof typeof FORMAT_BUTTONS;

export const ATTR_ALT_PATH: ExpressionPath = [
  {in: 'Record', at: 'attr'},
  {in: 'Record', at: 'alt'},
];

export const DEFAULT_FIGURE_ALIGNMENT = 'center';

export {FIGCAPTION_PLACEHOLDER_TEXT} from '@packages/shared/constants/Render';
